import { render, staticRenderFns } from "./addNedit-product.vue?vue&type=template&id=7d833a8b&scoped=true&"
import script from "./addNedit-product.vue?vue&type=script&lang=js&"
export * from "./addNedit-product.vue?vue&type=script&lang=js&"
import style0 from "./addNedit-product.vue?vue&type=style&index=0&id=7d833a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d833a8b",
  null
  
)

export default component.exports